import { Component, Input, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'getm-search-no-results',
  templateUrl: './search-no-results.component.html',
  styleUrls: ['./search-no-results.component.scss'],
})
export class SearchNoResultsComponent implements OnInit {

  @Input() search: string = '';
  @Input() variant: 'compact' | 'fullscreen' = 'fullscreen';
  @Input() imageUrl?: string;
  @Input() title?: string;
  @Input() description?: string;

  public image: string = '';
  public translatedTitle: string = '';
  public translatedDescription: string = '';

  constructor(private translateService: TranslateService) { }

  ngOnInit(): void {
    this.translateValues();
  }

  private translateValues(): void {
    const imageKey = this.imageUrl || 'Icons.icon-no-products';
    const titleKey = this.title || 'Titles.product-not-found';
    const descriptionKey = typeof this.description === 'string' ? this.description : 'Labels.search-no-results';

    this.image = this.translateService.instant(imageKey);
    this.translatedTitle = this.translateService.instant(titleKey);
    if (typeof this.description === 'string') {
      this.translatedDescription = this.description;
    } else {
      const search = this.search.length > 20 ? this.search.slice(0, 15) + '...' : this.search;
      this.translatedDescription = this.translateService.instant(descriptionKey, { search });
    }
  }

}
